import React from 'react';
import {z} from 'zod';

import {HorizontalRuleOutlined} from '@mui/icons-material';

import {Divider,DividerPropsSchema} from './Divider';
import DividerSidebarPanel from './DividerSidebarPanel';

export type DividerProps = z.infer<typeof DividerPropsSchema>;

export default {
    label: 'Divider',
    icon: <HorizontalRuleOutlined />,
    type: 'Divider',
    defaultData: {
        style: { padding: { top: 16, right: 0, bottom: 16, left: 0 } },
        props: {
            lineHeight: 1,
            lineColor: '#333333',
        },
    },
    SidebarPanel: DividerSidebarPanel,
    Component: Divider,
    schema: DividerPropsSchema,
};